import { COLOR_BACKGROUND_LEVEL_0_LIGHT, COLOR_BASE_GREY_0, COLOR_BASE_GREY_10 } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';
import { DefaultBarHeight, DefaultBarHeightBig } from '~/styles/default-bar';

type StyleProps = {
	isBodyNoneScroll: boolean;
	fullScreen?: boolean;
};

export const ServiceFooterStyle = styled.div<StyleProps>`
	position: ${(props) => (props.fullScreen ? 'fixed' : props.isBodyNoneScroll ? 'fixed' : 'sticky')};
	bottom: 0;
	top: calc(100% - ${DefaultBarHeightBig}px);
	background-color: ${COLOR_BACKGROUND_LEVEL_0_LIGHT};
	color: ${COLOR_BASE_GREY_0};
	box-shadow: 0 -1px 0 ${COLOR_BASE_GREY_10}; /* Simulating border-top */
	left: 0;
	right: 0;
	height: ${(props) => (props.fullScreen ? '100vh' : 'auto')};
	top: ${(props) => (props.fullScreen ? '0px' : 'unset')};
	overflow: ${(props) => (props.fullScreen ? 'auto' : 'unset')};
	z-index: 9;

	${breakPoints({
		'768': `top: calc(100% - ${DefaultBarHeight}px);`,
	})}
	.footer-container {
		height: ${DefaultBarHeightBig}px;
		justify-content: center;
		${breakPoints({
			'768': `height: ${DefaultBarHeight}px;`,
		})}
		&__inner-container {
			display: flex;
			flex-direction: column;
			width: 100%;
			.info-block {
				${breakPoints({
					'768': 'margin-left: auto;',
				})}
			}

			& .calculation-info-item {
				word-break: keep-all;
			}

			${breakPoints({
				'768': 'flex-direction: row;',
			})}
		}
	}

	.info-block {
		display: flex;
		flex-direction: column;

		${breakPoints({
			'768': 'flex-direction: row;',
		})}
	}

	.calculation {
		flex-grow: 0;
		flex-shrink: 0;
	}

	.marketing {
		flex-grow: 1;
		flex-shrink: 1;
	}
`;
